import React from 'react';
import './GoogleMap.css';

interface GoogleMapProps {
  address: string;
  title?: string;
}

export const GoogleMap: React.FC<GoogleMapProps> = ({ address, title = 'Casa do Pandeiro' }) => {
  // Codificar o endereço para URL do Google Maps
  const encodedAddress = encodeURIComponent(address);
  const mapUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodedAddress}`;

  return (
    <div className="google-map-container">
      <h3 className="map-title">{title}</h3>
      <div className="map-wrapper">
        <iframe
          className="google-map"
          src={mapUrl}
          width="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title={title}
        />
      </div>
      <div className="map-actions">
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`}
          target="_blank"
          rel="noopener noreferrer"
          className="map-link"
        >
          <i className="fas fa-external-link-alt"></i>
          Abrir no Google Maps
        </a>
      </div>
    </div>
  );
}; 